<template>
  <section class="page">
    <div class="scroll-wrap" :class="{ 'flex-1': !isFocus }">
      <section class="top">
        <div class="top-title">行程取消成功</div>
        <div class="top-tip">实际支付金额将原路退回</div>
      </section>
      <section class="addr" v-if="startName && endName">
        <div class="addr-l">
          <div class="addr-l-info">
            <div class="addr-l-info__start"></div>
            <span class="text-ellipsis">{{ startName }}</span>
          </div>
          <div v-if="pathwayText" class="addr-l-info">
            <div class="addr-l-info__path"></div>
            <span class="text-ellipsis">{{ pathwayText }}</span>
          </div>
          <div class="addr-l-info">
            <div class="addr-l-info__end"></div>
            <span class="text-ellipsis">{{ endName }}</span>
          </div>
        </div>
        <div v-if="isShowReschedule" class="addr-r" @click="handleReschedule">
          {{ rescheduleBtnName }}
        </div>
      </section>
      <section class="content">
        <section class="content-top">
          <div class="content-top-title">您为什么要取消？</div>
          <div class="content-top-desc">请告知取消原因，我们将努力改善</div>
        </section>
        <van-collapse
          class="content-collapse"
          v-model="collapseActiveItem"
          accordion
          :border="hasBorder"
        >
          <van-collapse-item
            v-for="(item, index) in reasonList"
            :key="index"
            :title="item.levelOneReason"
            :name="index"
            :border="hasBorder"
          >
            <div class="content-collapse__item">
              <div
                v-for="subItem in item.levelTwoReasonInfo"
                :key="subItem.id"
                class="content-collapse__item-row"
                @click="selectedReason(subItem)"
              >
                <div class="flex-center flex-justify-between">
                  <div class="content-collapse__item-row-txt">
                    {{ subItem.reason }}
                  </div>
                  <template v-if="activeId == subItem.id">
                    <img
                      class="content-collapse__item-row-icon"
                      src="@/assets/images/checked.png"
                      alt=""
                    />
                  </template>
                  <img
                    v-else
                    class="content-collapse__item-row-icon"
                    src="https://coupe-static.xiaolachuxing.com/image/cf21844b801a500fd70f43e8fe724553901b7cf5.png"
                    alt=""
                  />
                </div>
                <div
                  v-if="isShowBlockDriver && activeId == subItem.id"
                  class="content-collapse__item-row-tip"
                >
                  {{ rowTip }}
                </div>
              </div>
            </div>
          </van-collapse-item>

          <van-collapse-item title="其他" name="custom" :border="hasBorder">
            <textarea
              v-if="isShowTextarea"
              class="content-collapse__textarea"
              placeholder="如有其它取消原因，请在这里告诉我们"
              maxlength="120"
              v-model="inputReasonText"
              rows="4"
              :autofocus="isAutofocus"
              @input="onInput"
              @focus="handleFocus"
              @blur="handleBlur"
            >
            </textarea>
          </van-collapse-item>
        </van-collapse>
      </section>
    </div>

    <section class="bottom" :class="{ 'safe-bottom': !isFocus }">
      <div class="bottom-wrap">
        <xl-button
          size="xlarge"
          type="dark"
          block
          :disabled="!canSubmit"
          class="bottom-btn"
          @click="submit"
          >提交原因</xl-button
        >
        <div v-if="isShowBlockDriver" class="block-driver">
          <div
            v-if="!isBlock"
            class="block-driver__text flex-center"
            @click="blockDriver"
          >
            不想让该司机抢我的订单
            <img
              class="block-driver__arrow"
              src="@/assets/images/ic_right@2x.png"
              alt=""
            />
          </div>
          <div v-else class="block-driver__text flex-center">
            已拉黑，平台将不会推送你的订单给该司机
          </div>
        </div>
      </div>
    </section>

    <!-- 用来获取屏幕高度值，防止APP和小程序取值不一致 -->
    <div id="screenDiv"></div>
  </section>
</template>

<script>
import {
  fetchCancelOrderReasonList,
  fetchSubmitCancelOrderReason,
} from '@/api/modules/cancel';
import {
  fetchOrderDetails,
  fetchCarInfo,
  fetchBlockDriver,
} from '@/api/modules/order';
import { ClientUtil } from '@xl/js-utils';
import {
  isMiniProgram,
  mpNavigateBack,
  mpPostMessage,
  throttle,
} from '@/utils/base';
import { dealRevision } from '@/utils/tools';
import { isWxMiniProgram, isXlAppByClientType } from '@/utils/platforms';
import reasonListDefault from '@/common/reason-list';

export default {
  data() {
    return {
      orderId: '',
      orderStatus: '',
      orderUuid: '',
      reasonList: [],
      activeId: '',
      reasonDesc: '',
      inputReasonText: '', // 自定义取消原因
      collapseActiveItem: 0,
      hasBorder: false,
      isMp: false,
      isFocus: false,
      isAutofocus: true,
      driverReasonIndex: -1,
      isSelectDriverReason: false, // 选中的单选框是否为“司机原因”这一栏
      isSetBlock: false,
      orderData: {},
      ratedInfo: {},
      carInfo: {},
      rowTip: '平台将核实司机问题，若司机有责将严肃处理',
      addrInfo: [],
      passingAddrInfo: [],
      isClickedReschedule: false,
      orderSubType: '',
      productType: '',
    };
  },
  created() {
    this.orderId = this.$route.query.order_id;
    this.orderStatus = this.$route.query.order_status;
    this.orderType = this.$route.query.order_type;
    this.orderUuid = this.$route.query.order_uuid;
    this.productType = this.$route.query.product_type;
    try {
      this.addrInfo = JSON.parse(this.$route.query.addr_info);
    } catch (error) {
      console.info(error);
    }

    try {
      this.passingAddrInfo = JSON.parse(this.$route.query.passing_addr_info);
    } catch (error) {
      console.info(error);
    }

    if (this.orderId && this.orderStatus) {
      this.getReasonList();
      this.getOrderDetail();
    } else {
      this.$toast('缺少订单相关参数');
    }

    this.isMp = isMiniProgram();
  },
  mounted() {
    // 埋点，取消订单成功_曝光
    this.$sa.track('cancel_order_success_expo', {
      order_uuid: this.orderUuid,
      module_name: '再来一单按钮',
    });
  },
  computed: {
    // 是否为顺风车
    isCarpool() {
      return this.orderType == 103;
    },
    // 是否为企业单
    isEp() {
      return this.orderType == 101;
    },
    // 是顺风车类型，但不是小拉独享
    isNotExpress() {
      return this.isCarpool && this.productType !== 'EXCLUSIVE_EXPRESS';
    },
    rescheduleBtnName() {
      return this.isCarpool ? '重新预约' : '再来一单';
    },
    canSubmit() {
      return Boolean(this.inputReasonText || this.activeId);
    },
    isShowTextarea() {
      return this.collapseActiveItem === 'custom';
    },
    // 拉黑司机确认框文案
    comfirmCtx() {
      return (
        this?.ratedInfo?.blacklistMessage ||
        '司机加入黑名单后，3个月内平台将不会推送你的订单给该司机'
      );
    },
    // 是否显示拉黑司机入口（选中的单选框为司机原因 且 当前是在司机原因list）
    isShowBlockDriver() {
      return (
        this.isSelectDriverReason &&
        this.driverReasonIndex === this.collapseActiveItem
      );
    },
    // 是否已拉黑司机
    isBlock() {
      return Boolean(this?.ratedInfo?.isBlacklist) || this.isSetBlock;
    },
    startName() {
      return this.addrInfo[0]?.name || '';
    },
    endName() {
      return this.addrInfo[1]?.name || '';
    },
    // 只有微信小程序、APP，并且是新版本，才支持该页面的“再来一单”功能
    isShowReschedule() {
      if (this.isEp || this.isNotExpress) {
        return false;
      }
      let isSupport = false;
      const { revision } = this.$route.query || {};
      const version = dealRevision(revision);

      const rescheduleVersion = {
        mp: 308,
        app: 2326,
      };

      if (isWxMiniProgram()) {
        isSupport = version >= rescheduleVersion.mp;
      } else if (isXlAppByClientType()) {
        isSupport = version >= rescheduleVersion.app;
      }

      return isSupport;
    },
    pathwayText() {
      const text =
        this.passingAddrInfo?.map((item) => item.name)?.join('、') || '';
      if (text) {
        return `经${this.passingAddrInfo?.length}地: ${text}`;
      }
      return '';
    },
  },
  methods: {
    handleFocus() {
      this.isFocus = true;
      setTimeout(() => {
        window.scrollTo(0, 9999);
        let bottomWrapEl = document.querySelector('.bottom-wrap');
        let clientHeight = document.querySelector('#screenDiv').offsetTop;
        let h =
          clientHeight - (bottomWrapEl.offsetHeight + bottomWrapEl.offsetTop);
        setTimeout(() => window.scrollBy(0, 0 - h), 100);
      }, 400);
    },
    handleBlur() {
      this.isFocus = false;
    },
    async getReasonList() {
      let list = reasonListDefault;

      try {
        const { data } = await fetchCancelOrderReasonList({
          orderFrom: this.orderType,
        });
        list = data?.list || reasonListDefault;
      } catch (error) {
        // 网络失败时使用兜底数据
        console.info('fetchCancelOrderReasonList error:', error);
      }

      this.reasonList = list.filter(
        (item) =>
          item?.levelTwoReasonInfo && item?.levelTwoReasonInfo?.length > 0,
      );

      this.driverReasonIndex = this.reasonList.findIndex(
        (item) => item.levelOneReason === '司机原因',
      );

      if (this.reasonList.length === 0) {
        this.isAutofocus = false; // 只有单独的“其它”一项时，第一次进来不要聚焦
        this.collapseActiveItem = 'custom';
        setTimeout(() => (this.isAutofocus = true), 0);
      }
    },
    async getOrderDetail() {
      const { data = {} } = await fetchOrderDetails({
        orderId: this.orderId,
        orderUuid: this.orderUuid,
        needFeeDetail: 0,
      });
      this.orderData = data;
      this.ratedInfo = data?.ratingComment || {};
    },
    async getCarInfo() {
      const { data = {} } = await fetchCarInfo({
        param: {
          drierId: this.orderData.driverId,
          vehicleId: this.orderData.vehicleId,
          orderUuid: this.orderData.orderUuid || this.orderId,
        },
      });
      this.carInfo = data;
    },
    selectedReason(item) {
      if (this.activeId === item.id) {
        return this.clearReason();
      }
      this.activeId = item.id;
      this.reasonDesc = item.reason;
      this.inputReasonText = '';
      this.isSelectDriverReason =
        this.driverReasonIndex === this.collapseActiveItem;
    },
    clearReason() {
      this.activeId = '';
      this.reasonDesc = '';
      this.isSelectDriverReason = false;
    },
    onInput(e) {
      e.target.value && this.clearReason();
    },
    async submit() {
      if (!this.canSubmit) {
        this.$toast({
          message: '请选择原因',
          forbidClick: true,
          duration: 1000,
        });
        return;
      }

      // 埋点，取消订单成功_确认
      this.$sa.track('cancel_order_success_confirm', {
        order_uuid: this.orderUuid,
        cancel_reason: this.inputReasonText || this.reasonDesc,
      });

      await fetchSubmitCancelOrderReason({
        orderId: this.orderId,
        orderStatus: this.orderStatus,
        reasonCode: 70, // 固定传70
        reason: this.inputReasonText || this.reasonDesc,
      });

      this.$toast.success({
        message: '提交成功',
        forbidClick: true,
        onClose: () => {
          if (this.isMp) {
            mpPostMessage({ handler: 'cancelReasonSubmitted' }, mpNavigateBack);
          } else {
            ClientUtil.webcall({
              action: 'cancelOrderCallback',
            });
          }
        },
      });
    },
    blockDriver() {
      this.$sa.track('block_driver_click', {
        order_uuid: this.orderUuid,
        module_name: '不想让该司机抢我的订单',
        page_name: '取消订单',
      });
      this.$sa.track('block_confirm_popup_expo', {
        order_uuid: this.orderUuid,
        page_name: '取消订单',
      });
      // this.$confirm({
      //   title: '将司机加入黑名单',
      //   message: this.comfirmCtx,
      // })
      //   .then(() => {
      //     this.comfirmConfirm();
      //   })
      //   .catch(() => {
      //     this.comfirmCancel();
      //   });

      this.$dialog
        .confirm({
          title: '将司机加入黑名单',
          message: this.comfirmCtx,
        })
        .then(() => {
          this.comfirmConfirm();
        })
        .catch(() => {
          this.comfirmCancel();
        });
    },
    comfirmCancel() {
      this.$sa.track('block_confirm_popup_click', {
        order_uuid: this.orderUuid,
        module_name: '取消',
        page_name: '取消订单',
      });
    },
    async comfirmConfirm() {
      this.$sa.track('block_confirm_popup_click', {
        order_uuid: this.orderUuid,
        module_name: '确认',
        page_name: '取消订单',
      });
      this.$loading.show();

      await this.getCarInfo();
      await fetchBlockDriver({
        driverFid: this.carInfo?.driverFid,
        orderId: this.orderId,
        scene: 1,
      }).catch((error) => {
        this.$toast({
          message: error.message || 'error',
          forbidClick: true,
        });
        this.$loading.hide();
        throw 'fetchBlockDriver error';
      });

      this.$loading.hide();
      this.isSetBlock = true;

      this.$toast.success({
        message: '已加入黑名单',
        forbidClick: true,
      });
    },
    handleReschedule: throttle(function () {
      const isWx = isWxMiniProgram();
      // 微信小程序环境只允许点击一次。APP实现不同，是在调用action时就请求订单详情接口，请求成功了才跳回到原生页，可能会请求失败，允许重复点击
      if (this.isClickedReschedule && isWx) {
        return;
      }
      this.isClickedReschedule = true;
      if (isWx) {
        mpPostMessage(
          {
            handler: 'handleReschedule',
            orderId: this.orderId,
          },
          mpNavigateBack,
        );
      } else if (isXlAppByClientType()) {
        ClientUtil.webcall({
          action: 'handleReschedule',
          orderId: this.orderId,
          pageFrom: 'cancelPage', // 标识为取消原因页跳转的
        });
      }

      this.$sa.track('one_more_order_click', {
        order_uuid: this.orderUuid,
        module_name: this.rescheduleBtnName,
        order_status: this.orderStatus,
        page_name: '取消原因页',
      });
    }, 200),
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
.page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  background: #f7f8fb;
  display: flex;
  flex-direction: column;
  background-image: url('https://coupe-static.xiaolachuxing.com/image/a43ed0a4ffe597a41da328b24a99a7c9cf787af9.png');
  background-repeat: no-repeat;
}
.scroll-wrap {
  overflow-y: scroll;
  padding-bottom: 12px;
}
.top {
  padding: 32px 28px 16px;
  &-title {
    height: 31px;
    line-height: 31px;
    font-size: 22px;
    font-family: PingFang SC, PingFang SC-600;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }
  &-tip {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
  }
}
.addr {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.08);
  margin: 0 12px 12px 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &-l {
    overflow: hidden;
    &-info {
      display: flex;
      align-items: center;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 6px;
      position: relative;
      &::after {
        position: absolute;
        content: '';
        top: 15px;
        left: 2.5px;
        width: 1px;
        height: 10px;
        background-color: rgba(0, 0, 0, 0.1);
      }
      &:nth-last-of-type(1)::after {
        display: none;
      }
      &:nth-last-of-type(1) {
        margin-bottom: 0;
      }
      &__start,
      &__path,
      &__end {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        margin-right: 11px;
        flex-shrink: 0;
      }
      &__start {
        background: #00cae1;
      }
      &__path {
        background: #007aff;
      }
      &__end {
        background: #223259;
      }
    }
  }
  &-r {
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    background: #00cae1;
    border-radius: 8px;
    font-size: 12px;
    font-family: @font-family;
    color: #ffffff;
    flex-shrink: 0;
    margin-left: 8px;
  }
}
.content {
  margin: 0 12px;
  padding: 16px 12px 0 12px;
  box-sizing: border-box;
  border-radius: 14px;
  background-color: #fff;
  .content-top {
    margin-bottom: 16px;
    padding: 0 4px;
    .content-top-title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .content-top-desc {
      margin-top: 4px;
      font-size: 12px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #666;
    }
  }
  .content-collapse {
    // 魔改一下 vant 折叠面板的样式
    .van-collapse-item {
      /deep/ &__content {
        padding: 0;
        font-size: 0;
      }
      /deep/ .van-cell {
        padding: 15px 9px 15px 4px;
        align-items: center;
        &__title {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
        }
        &__right-icon {
          height: 16px;
          line-height: 16px;
        }
      }
      /deep/ .van-cell:active {
        background-color: transparent;
      }
    }

    &__item {
      background: #f7f8fb;
      border-radius: 8px;
      padding: 4px 8px 4px 12px;
      &-row {
        padding: 12px 0;
        &-txt {
          height: 17px;
          line-height: 17px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
        &-icon {
          width: 16px;
          height: 16px;
        }
        &-tip {
          min-height: 17px;
          line-height: 17px;
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
          margin: 2px 0 -8px 0;
        }
      }
    }

    &__textarea {
      width: 100%;
      height: 76px;
      resize: none;
      background: rgba(244, 244, 244, 0.6);
      border-radius: 8px;
      padding: 8px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      box-sizing: border-box;
      margin-bottom: 16px;
      color: black;
    }
  }
}

.bottom {
  background-color: #fff;
  &-wrap {
    padding: 12px;
    box-sizing: border-box;
    .block-driver {
      &__text {
        height: 17px;
        line-height: 17px;
        margin-top: 16px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
      &__arrow {
        width: 17px;
        height: 17px;
        transform: translateY(-0.5px);
      }
    }
    .bottom-btn {
      font-family: @font-family;
      font-weight: 500;
    }
  }
}

#screenDiv {
  position: fixed;
  bottom: 0;
}
.goods-btn-bg {
  background: #ff6600;
  border-color: #ff6600;
}
</style>
